export default class FormsHelper {
    // #region Components
    componentSummaryName(name) {
        if (name === 'InputField') {
            return 'g-ozg-input-summary';
        }
        else if (name === 'Separator') {
            return 'g-ozg-separator-summary';
        }
        else if (name === 'InputSelect') {
            return 'g-ozg-select-summary';
        }
        else if (name === 'Headline') {
            return 'g-ozg-headline-summary';
        }
        else if (name === 'FileUpload') {
            return 'g-ozg-file-summary';
        }
        else if (name === 'PlainText') {
            return 'g-ozg-empty-summary';
        }
        else if (name === 'Hyperlink') {
            return 'g-ozg-empty-summary';
        }
        else if (name === 'HtmlText') {
            return 'g-ozg-empty-summary';
        }
        else {
            return 'g-ozg-todo-summary';
        }
    }
    componentElementName(name) {
        if (name === 'PlainText') {
            return 'g-ozg-text-element';
        }
        else if (name === 'Separator') {
            return 'g-ozg-separator-element';
        }
        else if (name === 'HtmlText') {
            return 'g-ozg-html-element';
        }
        else if (name === 'Hyperlink') {
            return 'g-ozg-link-element';
        }
        else if (name === 'Headline') {
            return 'g-ozg-headline-element';
        }
        else if (name === 'InputField') {
            return 'g-ozg-input-element';
        }
        else if (name === 'InputSelect') {
            return 'g-ozg-select-element';
        }
        else if (name === 'FileUpload') {
            return 'g-ozg-file-element';
        }
        else {
            return 'g-ozg-empty-element';
        }
    }
    componentPageName(name) {
        if (name === 'data' || name === 'data_service') {
            return 'g-ozg-data-page';
        }
        else if (name === 'info') {
            return 'g-ozg-info-page';
        }
        else if (name === 'multi') {
            return 'g-ozg-multi-page';
        }
        else if (name === 'payment') {
            return 'g-ozg-payment-page';
        }
        else if (name === 'summary') {
            return 'g-ozg-summary-page';
        }
        else if (name === 'confirmed') {
            return 'g-ozg-confirmed-page';
        }
        else {
            return 'g-ozg-empty-page';
        }
    }
    // #endregion
    // #region Helper
    getDataForEval(schema, data, page) {
        let tData = {
            form: {
                data: data,
                schema: schema,
                process: schema,
                page: page,
                pages: schema.allPages,
                pageData: page ? forms.getPageDataAsObject(page, data) : undefined
            }
        };
        return tData;
    }
    getAllPagesAsObject(source, filter) {
        //Object
        let tArray = [];
        let tObject = {};
        //Load
        this.getAllPages(tArray, source, filter);
        //Build
        tArray.forEach(e => {
            tObject[e.name] = e;
        });
        return tObject;
    }
    getPageDataAsObject(page, data) {
        let tObject = {};
        if (page.content) {
            page.content.forEach((e) => {
                if (e.fields) {
                    e.fields.forEach((c) => {
                        tObject[e.name] = data[c.member];
                    });
                }
            });
        }
        return tObject;
    }
    getAllPages(target, source, filter) {
        source.forEach(e => {
            //Self
            if (!filter || filter(e)) {
                target.push(e);
            }
            //Children
            if (e.pages) {
                this.getAllPages(target, e.pages, filter);
            }
        });
    }
    findFirstPage(pages) {
        let tPages = [];
        {
            this.getAllPages(tPages, pages, e => e.pageType !== 'group' && e.isEnabled === true);
        }
        if (tPages.length > 0) {
            return tPages[0];
        }
        else {
            return null;
        }
    }
    findPageByName(pages, name) {
        if (utils.isNullOrEmpty(name)) {
            return null;
        }
        for (let tPage of pages) {
            //Self
            if (tPage.name === name) {
                return tPage;
            }
            //Sub-Pages                   
            if (tPage.pages) {
                let tSub = this.findPageByName(tPage.pages, name);
                if (tSub) {
                    return tSub;
                }
            }
        }
        return null;
    }
    isEvalValid(condition, data) {
        try {
            if (!condition) {
                return true;
            }
            else {
                return utils.evalExpression(data, condition);
            }
        }
        catch {
            utils.logError("error-on-isVisible", condition, data);
            return false;
        }
    }
    isVisible(element, data) {
        try {
            if (!element.condition) {
                return true;
            }
            else {
                return utils.evalExpression(data, element.condition);
            }
        }
        catch {
            utils.logError("error-on-isVisible", element, data);
            return false;
        }
    }
    isEnabled(element, data) {
        try {
            if (!element.condition) {
                return true;
            }
            else {
                return utils.evalExpression(data, element.condition);
            }
        }
        catch {
            utils.logError("error-on-isEnabled", element, data);
            return false;
        }
    }
    // #endregion
    // #region Validation
    isFinished(e) {
        let tHasFields = false;
        if (e.content && e.isEnabled) {
            for (var tContent of e.content) {
                if (tContent.isVisible === false)
                    continue;
                if (tContent.validationRules && tContent.validationRules.length > 0) {
                    for (var tItem of tContent.fields) {
                        if (tContent.isOptional && tItem.validation == null)
                            continue;
                        if (tItem.validation?.state === 'critical') {
                            return "critical";
                        }
                        else if (tItem.validation?.state === 'invalid') {
                            return "invalid";
                        }
                        else if (tItem.validation?.state !== 'succeeded') {
                            return "pending";
                        }
                    }
                    tHasFields = true;
                }
            }
        }
        if (tHasFields) {
            return 'succeeded';
        }
        else {
            return 'none';
        }
    }
    isValid(state) {
        if (state === "invalid" || state === "critical" || state === "pending") {
            return false;
        }
        else {
            return true;
        }
    }
    isValidationStateForSave(state) {
        return state === "invalid" || state === "critical" || state === "succeeded";
    }
    getAllErrorMessages(page, additionalMessages = undefined) {
        let tData = [];
        if (additionalMessages) {
            additionalMessages.forEach(m => {
                tData.push(m);
            });
        }
        if (page.content) {
            page.content.forEach((c) => {
                if (c.fields) {
                    c.fields.forEach((f) => {
                        if (f.validation && f.validation.showAsMessage) {
                            tData.push({
                                text: f.validation.message,
                                member: f.member
                            });
                        }
                    });
                }
            });
        }
        return tData;
    }
}
